import { Redirect } from 'react-router-dom';
import { ReactElement, useState } from 'react';
import FilterBar from '../filterBar';
import Header from '../navbar';
import useOrdersData from '../ordersTable/useOrdersData';
import {
  GlobalStyle,
  GreyBackground,
  StickyContainer,
  TableContainer,
} from './styles';
import { NullableNumber, NullableString } from '@app/common/types';
import useOrdersFilters from '../filterBar/useOrdersFilters';
import Pagination from '@root/src/app/designSystem/pagination';
import OrdersTypeTable from '../ordersTable';

const Dashboard = (): ReactElement => {
  const [selectedOrderId, setSelectedOrderId] = useState<
    NullableNumber | NullableString
  >(null);
  const { totalCount } = useOrdersData();

  const { onPageChanged, filters } = useOrdersFilters();

  return (
    <>
      {selectedOrderId ? (
        <Redirect to={`/order/${selectedOrderId}`} />
      ) : (
        <Redirect to="/dashboard" />
      )}
      <GlobalStyle />
      <GreyBackground>
        <StickyContainer>
          <Header />
          <FilterBar />
        </StickyContainer>
        <TableContainer>
          <OrdersTypeTable
            ordersType={filters.ordersState}
            setSelectedOrderId={setSelectedOrderId}
          />
        </TableContainer>
        {totalCount > filters.limit && (
          <Pagination
            data-testid={`healthcheck-dashboard-pagination`}
            currentPage={filters.page}
            totalRecords={totalCount}
            pageLimit={filters.limit}
            onPageChanged={onPageChanged}
          />
        )}
      </GreyBackground>
    </>
  );
};

export default Dashboard;
